<template>
  <div class="mileage-mobile">
    <!-- Filter summary bar -->
    <mileage-filter-row 
      @click="filterVisible = true"
      :filter="filter"
      :count="rows.length"
      :total="total"
    ></mileage-filter-row>

    <!-- Action buttons -->
    <div class="container-fluid px-0 my-2">
      <div class="row g-2">
        <div class="col-4">
          <button @click="refresh()"
            class="btn btn-primary form-control"
          >
            <i class="fa fa-sync"></i> Refresh
          </button>
        </div>
        <div class="col-4">
          <button @click="newRecord()"
            class="btn btn-success form-control"
          >
            <i class="fa fa-plus"></i> New
          </button>
        </div>
        <div class="col-4">
          <button @click="filterVisible = true"
            class="btn btn-outline-secondary form-control"
          >
            <i class="fa fa-filter"></i> Filter
          </button>
        </div>
      </div>
    </div>

    <hr class="my-2" />

    <!-- Mobile-optimized list view -->
    <div class="mobile-mileage-list">
      <div v-for="row in rows" :key="row.Id" class="mileage-card mb-2" @click="editRecord(row.Id)">
        <div class="card">
          <div class="card-body p-2">
            <div class="d-flex justify-content-between align-items-start mb-2">
              <div class="flex-grow-1">
                <strong>{{ row.Contact?.Company || 'N/A' }}</strong>
                <div class="text-muted small" v-if="row.Description">{{ row.Description }}</div>
              </div>
              <div class="text-end ms-2">
                <span class="badge bg-info">
                  {{ row.Miles || 0 }} mi
                </span>
              </div>
            </div>
            
            <div class="row small mb-1">
              <div class="col-12" v-if="row.StartLocation || row.EndLocation">
                <i class="fas fa-route me-1"></i>
                {{ row.StartLocation || 'Start' }} → {{ row.EndLocation || 'End' }}
              </div>
            </div>
            
            <div class="small mb-1" v-if="row.Request?.Id">
              <i class="fas fa-ticket-alt me-1"></i>Request #{{ row.Request.Id }}
            </div>
            
            <div class="small mb-1" v-if="row.Technician?.TechnicianName">
              <i class="fas fa-user me-1"></i>{{ row.Technician.TechnicianName }}
            </div>
            
            <div class="small text-muted" v-if="row.Date">
              <i class="fas fa-calendar me-1"></i>{{ getLocalDate(row.Date) }}
            </div>
          </div>
        </div>
      </div>
      
      <!-- Empty state -->
      <div v-if="rows.length === 0" class="text-center text-muted py-5">
        <i class="fas fa-car fa-3x mb-3"></i>
        <p>No mileage entries found</p>
      </div>
    </div>

    <!-- Filter Modal -->
    <kt-modal 
      :visible="filterVisible" 
      title="Filter Mileage" 
      @dismiss="filterVisible = false"
    >
      <template #body>
        <mileage-filter
          :filter="filter" 
          @dismiss="filterVisible = false" 
          @update="setFilter($event)"
        ></mileage-filter>
      </template>
    </kt-modal>
  </div>
</template>

<style scoped>
.mileage-mobile {
  padding: 0.5rem;
}

.mileage-card {
  cursor: pointer;
  transition: transform 0.2s;
}

.mileage-card:active {
  transform: scale(0.98);
}

.mileage-card .card {
  border-left: 3px solid #0dcaf0;
}

.mobile-mileage-list {
  max-height: calc(100vh - 200px);
  overflow-y: auto;
}
</style>

<script setup lang="ts">
import { ref } from "vue";
import Helper from "@/services/Helper";
import KtModal from "@/components/UI/KtModal.vue";
import MileageFilterRow from "@/components/Mileage/MileageFilterRow.vue";
import MileageFilter from "@/components/Mileage/MileageFilter.vue";

// Props - receive data from parent
const props = defineProps<{
  rows: any[];
  total: number;
  filter: any;
}>();

// Emits
const emit = defineEmits<{
  refresh: [];
  newRecord: [];
  editRecord: [id: number];
  setFilter: [filter: any];
}>();

const filterVisible = ref(false);

// Methods
const refresh = () => {
  emit('refresh');
};

const newRecord = () => {
  emit('newRecord');
};

const editRecord = (id: number) => {
  emit('editRecord', id);
};

const setFilter = (filter: any) => {
  emit('setFilter', filter);
  filterVisible.value = false;
};

const getLocalDate = (val: any) => {
  if (!val) return '';
  let tmp = new Date(val);
  return Helper.dateToInput(tmp, Helper.DateFormat_Date);
};
</script>
